import React, { useRef } from 'react';
import classNames from 'classnames';
import { firstDefined } from 'utils';
import { useBootstrapBreakpoint, useHistory } from 'hooks';
import DropdownButton from 'components/DropdownButton';
import Icon from 'components/Icon';

const ORDER_CREATED = '-created';
const ORDER_UPDATED = '-updated';

export default function useOrderingMenu ({
  paramName = 'ordering',
  options = [
    { label: 'Created', value: ORDER_CREATED },
    { label: 'Updated', value: ORDER_UPDATED },
  ],
  defaultValue,
}) {
  const orderingMenuRef = useRef();
  const { location: { queryParams }, updateQueryParams } = useHistory();
  const isMobile = useBootstrapBreakpoint('down-md');

  let orderingVal;
  if (queryParams) {
    orderingVal = firstDefined(queryParams[paramName], defaultValue, options[0].value);
  }
  const activeOption = options.find(opt => opt.value === orderingVal);

  const handleOrderChange = (evt, ordering) => {
    evt.preventDefault();
    updateQueryParams({ ordering });
    orderingMenuRef.current.close();
  };

  const orderingButtonLabel = isMobile ? null : (
    <>
      <strong className="text-light-alt">Sort by: </strong>
      <strong>{activeOption && activeOption.label}</strong>
    </>
  );

  const orderingMenu = !!activeOption && (
    <DropdownButton
      ref={orderingMenuRef}
      text={orderingButtonLabel}
      appendIcon={isMobile ? <Icon i={['faz', 'sort']} /> : undefined}
      buttonClassName={classNames('clear', 'subtle-focus', 'borderless', isMobile && 'circle')}
      menuAnchor="right"
    >
      <div className="link-list py-3" style={{ width: 160 }}>
        {options.map(({ label, value }) => {
          const isActive = value === activeOption.value;
          return (
            <a
              key={value}
              href={`#${value}`}
              className={classNames('link-list-item', 'px-3', isActive && 'color-primary')}
              onClick={evt => handleOrderChange(evt, value)}
            >
              <Icon i={['far', 'check']} style={{ visibility: isActive ? 'visible' : 'hidden' }} />
              <span>{label}</span>
            </a>
          );
        })}
      </div>
    </DropdownButton>
  );

  return { orderingVal, orderingMenu };
}
